export class PartNumberEquivalent {

    public id: number;
    public name: string;
    public description: string;
    public valueStream: string;
    public sapGroup: string;
    public sapFamily: string;

    constructor(partNumberEquivalent: any = {}) {
        this.id = partNumberEquivalent.id || 0;
        this.name = partNumberEquivalent.name || '';
        this.description = partNumberEquivalent.description || '';
        this.valueStream = partNumberEquivalent.valueStream || '';
        this.sapGroup = partNumberEquivalent.sapGroup || '';
        this.sapFamily = partNumberEquivalent.sapFamily || '';
    }

    get nameWithSAP() {
        return `${this.name} ( ${this.sapGroup} - ${this.sapFamily} )`
    }
}

